import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shipment-receiving',
  templateUrl: './shipment-receiving.component.html',
  styleUrls: ['./shipment-receiving.component.scss']
})
export class ShipmentReceivingComponent implements OnInit {

  constructor() { }
  shipments = [];
  ngOnInit() {
  }
  change = false;
  showValidateCourier = true;
  showShipments = false
  onShipments(_shipments) {
    this.change = false;
    this.shipments = _shipments;
    this.showValidateCourier = false;
    this.showShipments = true;
  }
  onClosingTrip(event) {
    this.showValidateCourier = true;
    this.showShipments = false;
    this.change = true;
    this.shipments = [];
  }
}
